// extracted by mini-css-extract-plugin
export default {"md":"768px","navbarHeight":"48px","primary":"#40798c","secondary":"#ff5050","tertiary":"#32a852"};